import { toast } from "react-toastify";

export const handleApiError = (error) => {
  if (!error.response) {
    toast.error("Network error. Please check your connection.");
    return;
  }

  const { status, data } = error.response;

  if (status === 422 && data?.errors) {
    // Show each validation message
    Object.values(data.errors).flat().forEach((msg) => toast.error(msg));
    return;
  }

  const message = data?.message || "Something went wrong. Please try again.";
  toast.error(message);
};
